import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import { isNumericField } from "../../../utils/isNumericField.ts";
import SwitchMenuItem from "./SwitchMenuItem";

interface Props {
  field: ReportField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
  tooltip?: string;
}

export default function ReverseSignMenuItem({ field, saveChanges, readonly, tooltip }: Props) {
  if (!isNumericField(field)) {
    return null;
  }

  return (
    <SwitchMenuItem
      caption="Reverse Sign"
      value={!!field.config.reverseSign}
      onClick={() => saveChanges({ reverseSign: !field.config.reverseSign }, false)}
      disabled={readonly}
      tooltip={tooltip}
    />
  );
}
